import gameImport from './../game';
import cockft from './../../images/game2/cockft/img-sv388.png';
import scockft from './../../images/game2/cockft/img-sv388-s.png';

var gameMenu = {
  name: 'COCKFT',
  items: [
    {
      name: 'SV388',
      isFullWidth: true,
      provider: 'game hall',
      icon: gameImport.find((x) => x.code.toString() === '39').icon,
      code: '39-103',
      img: [{ langId: 0, src: cockft }],
      img2: [{ langId: 0, src: scockft }],
      isNew: false,
      labelName: '',
      parentName: '',
    },
  ],
};

export default gameMenu;
